// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body{font-family:Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:13px;color:#3e4855;background-color:inherit;line-height:1.42857143}@media (max-width:650px){.body{font-size:10px}}", ""]);
// Exports
module.exports = exports;
